import React from 'react';

import * as ReturnAuthorizationsTable from '../ReturnAuthorizationTable/ReturnAuthorizationTable';
import { QueryReturnAuthorizationsFilterInput } from 'generated/graphql';



export interface IProps {
  storeId?: string;
}

export const FC: React.FC<IProps> = props => {
  const filter = React.useMemo(
    (): QueryReturnAuthorizationsFilterInput => ({
      storeId: props.storeId,
      authorizationApprovalStatus: ['pending']
    }),
    [props.storeId]
  );

  return (
    <ReturnAuthorizationsTable.FC
      filter={filter}
      columnIdsToRender={[
        'requestDate',
        'orderNumber',
        'orderDate',
        'orderAmount',
        'customerPhoneNumber',
        'netSuiteSalesOrderRecord',
        'itemsFulfilledCount',
        'itemsToBeReturnedCount',
        'approveDenyRequest'
      ]} />
  );
};
